import { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseDashboard } from "./UseDashboard";
import { useNavigate } from "react-router-dom";
import ProgressCom from "../../src/components/ProgressCom";
import Detail from "../../src/main/detail/Detail";
import { rsActiveMenu, rsParentChilds } from "../../src/RecoilStates";
import { useRecoilState } from "recoil";
import { readFromLS } from "../util/LocalStrogeService";
import { useSnackbar } from "notistack";
import CustomPagination from "../components/CustomPagination";

function Dashboard() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { getDashList } = UseDashboard();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [dashRes, setDashRes] = useState();
  const [parentID, setParentID] = useRecoilState(rsParentChilds);
  const [addresPrint, setAddresPrint] = useState(readFromLS("addresPrint"));
  const [factorPrint, setFactorPrint] = useState(readFromLS("factorPrint"));

  const clearCacheData = () => {
    let configVersion = window.ENV.versionCode;
    let LSVersion = localStorage.getItem("VersionCode");

    if (LSVersion == null && configVersion) {
      window.location.reload(true);
      localStorage.setItem("VersionCode", configVersion);
    } else if (LSVersion !== configVersion) {
      window.location.reload(true);
      localStorage.setItem("VersionCode", configVersion);
    } else if (LSVersion === configVersion) {
    }
  };

  useEffect(() => {
    setParentID({
      id: null,
      name: "",
      scrolParent: { top: 0, left: 0 },
    });
    clearCacheData();
    getDashList((visitedPages) => {
      setDashRes(visitedPages);
    });
  }, []);

  const columns = [
    {
      field: "persianDate",
      headerName: " تاریخ ",
      align: "center",
      headerAlign: "center",
      width: 220,
      sortable: false,
    },
    {
      field: "persianTime",
      headerName: " زمان",
      width: 100,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "pageTitle",
      headerName: "نام صفحه",
      width: 200,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "state",
      headerName: "وضعیت",
      width: 150,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "مشاهده",
      headerName: "مشاهده",
      width: 160,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Button
            color="secondary"
            variant="contained"
            onClick={() => {
              if (
                cellValues.row.pageAddress == "orders" &&
                !addresPrint &&
                !factorPrint
              ) {
                enqueueSnackbar("لطفا ابتدا تنظیمات را تکمیل کنید", {
                  variant: "error",
                  autoHideDuration: 2000,
                });
                navigate("/setting");
                return;
              }
              navigate(`/${cellValues.row.pageAddress}`, {
                state: { model: cellValues.row.id },
              });
              setMsActiveMenu({
                id: cellValues.row.id,
                pageTitle: cellValues.row.pageTitle,
              });
            }}
          >
            مشاهده صفحه
          </Button>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "صفحه نخست",
        childs: [{ name: msActiveMenu.pageTitle, url: "/" }],
      }}
    >
      {dashRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={dashRes.visitedPages}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              isLtr: true,
              nofab: true,
              noPage: true,
            },
          }}
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}

export default Dashboard;
